export default {
  state: {
    addCouponInfo: '',
    backupGoodsInfo: '',
    storeList: '',
    routerDelta: '',
    token: '',
    merchantId: '',
    validCouponNum: 0,
    hasTemplateMiniApp: false
  },
  getters: {
    addCouponInfo (state) {
      return state.addCouponInfo
    },
    getBackupGoodsInfo (state) {
      return state.backupGoodsInfo
    },
    couponStoreList (state) {
      return state.storeList
    },
    routerDelta (state) {
      return state.routerDelta
    },
    getShareToken: state => state.token,
    getMerchantId: state => state.merchantId,
    getValidCouponNum: state => state.validCouponNum,
    getHasTemplateMiniApp: state => state.hasTemplateMiniApp
  },
  mutations: {
    setAddCouponInfo (state, data) {
      state.addCouponInfo = data
    },
    setBackupGoodsInfo (state, data) {
      state.backupGoodsInfo = data
    },
    setSelectedStore (state, data) {
      state.storeList = data
    },
    setRouterDelta (state, data) {
      state.routerDelta = data
    },
    setShareToken (state, data) {
      state.token = data
    },
    setMerchantId (state, data) {
      state.merchantId = data
    },
    setValidCouponNum (state, data) {
      state.validCouponNum = data
    },
    setHasTemplateMiniApp (state, data) {
      state.hasTemplateMiniApp = data
    }
  }
}
